// CANONICAL COPY (GH #7115). src/constants/obligations/obl-dpa-instruction-conflict-notification.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-dpa-instruction-conflict-notification',
  title: 'Verify DPA-instruction conflict notification procedure',
  description:
    "Confirm that the processor has a procedure to immediately notify the controller when an instruction is believed to violate GDPR or other EU / member-state data-protection law (GDPR Art. 28(3) second subparagraph; FSR ISAE 3000 Kontrolmål A.3). The procedure shall define who can raise the concern, escalation criteria, form of notification to the controller (in writing, without undue delay), and the processor's right to pause the processing pending controller response. Review the conflict-notification standard and any recorded conflict events.",
  category: 'compliance',
  scfIds: ['SCF-PRV-001', 'SCF-GOV-009'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'DPA-instruction conflict notification procedure is published',
    },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
